// extracted by mini-css-extract-plugin
module.exports = {"numeric-border":"styles_numeric-border__1fJlx","numeric-border-color":"styles_numeric-border-color__3Say3"};